// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IMessageOfferSchema {
  /** URL для аналитики **/
  analyticsUrl?: string;
  /** Timestamp создания пачки объявлений **/
  batchTs?: number;
  /** Строка с информацией об адресе **/
  formattedAddress: string;
  /** Строка с прочей информацией об объявлении **/
  formattedInfo: string;
  /** Строка с информацией о цене **/
  formattedPrice: string;
  /** Доступен ли эксперт **/
  isExpertEnabled?: boolean;
  /** GUID поисковой сессии, в рамках которой нашлось объявление **/
  mlSearchSessionGuid?: string;
  /** Фотографии объявления **/
  photoUrls: string[];
  /** Позиция в пачке объявлений рамках одного batch_ts **/
  position?: number;
  /** Текст ответа **/
  reaction?: EReaction;
  /** Идентификатор объявления **/
  realtyOfferId: number;
}

export enum EReaction {
  /** Не нравится **/
  'Dislike' = 'dislike',
  /** Нравится **/
  'Like' = 'like',
}
